import { Component } from "@angular/core";
import {AlertController, App, LoadingController, NavController, NavParams, ViewController} from "ionic-angular";
import {AppDialog} from "../../component/appDialog";
import {HabaGamesPlay} from "../habaGamesPlay/habaGamesPlay";
import {CommonService} from "../../services/common.service";
import {HabaHelpLink} from "../habaHelpLink/habaHelpLink";
import {HabaServices} from "../../services/haba.services";
import {ThirdpartyGame} from "../thirdpartyGame/thirdpartyGame";
import {TabsPage} from "../tabs/tabs";

@Component({
    templateUrl: 'habaGames.html',
    selector: 'haba-games'
})

export class HabaGames {
    private balanceHaba: number = 0;
    private listGames: any = [];
    private banner: string = '';
    private timeInterValLoadBalance: any;

    constructor(private navParams: NavParams, private alertCtrl: AlertController, private app: App, public cs: CommonService, private habaServices: HabaServices, private loadingCtrl: LoadingController,
                private nav: NavController, private viewCtrl: ViewController){
        let getData = navParams.data;
        this.gameInit(getData);
    }

    gameInit(dataPass) {
        if (dataPass.hasOwnProperty('bannerTop') && dataPass.bannerTop != '') {
            this.banner = dataPass.bannerTop;
        }
        if (dataPass.gameName.length === dataPass.keyName.length && dataPass.branchID !== '' && dataPass.userToken !== '') {
            for (let i = 0; i < dataPass.gameName.length; i++) {
                let keyNameStr = dataPass.keyName[i].substr(dataPass.keyName[i].lastIndexOf('/') + 1);
                let habaItem = {};
                habaItem["title"] = dataPass.gameName[i];
                habaItem["link"] = dataPass.gameLaunchUrl+'?ts=session&brandid='+dataPass.branchID+'&keyname='+keyNameStr+'&token='+dataPass.userToken+'&mode='+dataPass.modePlay+'&locale='+dataPass.locale;
                habaItem["helpLink"] = 'https://help-a.insvr.com/game/?keyname='+keyNameStr+'&locale='+dataPass.locale;
                habaItem["keyName"] = dataPass.keyName[i];
                habaItem["gameTypeId"] = "SlotGame";
                this.listGames.push(habaItem);
            }
        }else {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: "Có lỗi xảy ra. Vui lòng thoát ra và đăng nhập lại!"
            });
        }
    }

    gotoPlayHabaPage(link, title) {
        this.app.getRootNav().push(HabaGamesPlay, {
            link: link,
            title: title
        });
    }

    gotoHelpPage(helpLink, title) {
        this.app.getRootNav().push(HabaHelpLink, {
            link: helpLink,
            title: title
        });
    }

    ionViewWillEnter() {
        this.loadBalance();
        this.timeInterValLoadBalance = setInterval(() => {
            this.loadBalance();
        }, 10000);
    }

    ionViewWillLeave() {
        clearInterval(this.timeInterValLoadBalance);
    }

    loadBalance() {
        this.habaServices.habaGetBalance({}, {}).then(data => {
            if (data["sessionToken"] === "") {
                clearInterval(this.timeInterValLoadBalance);
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: "Phiên chơi game của bạn đã hết. Chọn 'OK' để đăng nhập lại.",
                    callBack: () => {
                        this.habaServices.habaLogin({}, this).then(data => {
                            if (data['msg'] === '') {
                                this.gameInit(data);
                                this.timeInterValLoadBalance = setInterval(() => {
                                    this.loadBalance();
                                }, 10000);
                            }else {
                                AppDialog.alert({
                                    alertCtrl: this.alertCtrl,
                                    message: data['msg'],
                                    callBack: () => {
                                        this.nav.push(TabsPage, {selectTab: 1}).then(() => {
                                            let index = this.viewCtrl.index;
                                            this.nav.remove(index);
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }else {
                this.balanceHaba = data["balance"];
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/habaGames/habaGames.ts